import { USER_ROLE_CONFIG_STATE_KEY } from './reducer';

const getState = (root: any) => root[USER_ROLE_CONFIG_STATE_KEY] || {};

export const getRoles = (root: any) => getState(root).roles || [];
export const getRolesLoading = (root: any) => !!getState(root).rolesLoading;

export const getPermissionsList = (root: any) => getState(root).permissionsList || [];
export const getPermissionsLoading = (root: any) => !!getState(root).permissionsLoading;

// NOTE: stable selector functions that accept state and roleId
export const getRolePermissions = (root: any, roleId: number) => {
  const map = getState(root).rolePermissions || {};
  return map[roleId] || [];
};
export const getRolePermissionsLoading = (root: any) => !!getState(root).rolePermissionsLoading;

export const getRoleUsers = (root: any, roleId: number) => {
  const map = getState(root).roleUsers || {};
  return map[roleId] || [];
};

export const getRoleUsersLoading = (root: any) => !!getState(root).roleUsersLoading;

export const getSavingPermissions = (root: any) => !!getState(root).savingPermissions;
export const getSavingUsers = (root: any) => !!getState(root).savingUsers;
export const getSavingRole = (root: any) => !!getState(root).savingRole;
export const getUserRoleConfigError = (root: any) => getState(root).error;
export const getUserRoleMappingSaving = (root: any) => !!getState(root).mappingSaving;
export const getUserRoleMappingError = (root: any) => getState(root).mappingError;

export const getPermissionMappings = (root: any, permissionId: number) => {
  const map = getState(root).permissionMappings || {};
  return map[permissionId] || { Roles: [], Users: [] };
};

export const getPermissionMappingsLoading = (root: any) => !!getState(root).permissionMappingsLoading;
